<template>
  <div>
    <!--   <button
      style="position: absolute; right: 300px; top: 100px; z-index: 100"
      @click="test()"
    >
      Hello
    </button> -->
    <transition-group name="slide" tag="div">
      <div
        :class="{
          'alert-card': true,
          'alert-success': item.type == 'SUCCESS',
          'alert-error': item.type == 'ERROR',
          'alert-info': item.type == 'INFO',
        }"
        v-for="(item, idx) in OnItems"
        :key="item.order"
        :style="{
          'margin-top': `${item.title.length < 25 ? idx * 55 : idx * 60}px`,
        }"
      >
        <div class="alert-content">
          <img :src="iconByType(item.type)" class="alert-icon" />

          <span class="alert-title" v-if="item.title.length < 25">
            {{ item.title }}
          </span>
          <div class="alert-title-long" v-else>
            {{ item.title }}
          </div>
          <i class="fa fa-close alert-close" @click="pop(idx)" />
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  data() {
    return {
      items: [],
      show: false,
      index: 0,
    };
  },
  computed: {
    ...mapGetters({ alert: "getAlert" }),
    OnItems() {
      return this.$funcs.copy(this.items).reverse();
    },
  },
  watch: {
    alert(val) {
      if (val) {
        this.add(val);
        this.setAlert(null);
      }
    },
  },
  methods: {
    ...mapMutations({ setAlert: "SET_ALERT" }),
    test() {
      this.setAlert({
        type: "SUCCESS",
        title: "정상적으로 등록되었습니다.",
      });
      this.setAlert({
        type: "ERROR",
        title: "정상적으로 등록되었습니다.",
      });
      this.setAlert({
        type: "INFO",
        title: "정상적으로 등록되었습니다.",
      });
    },
    add(data) {
      data.order = this.index;
      data.closeIn = data.closeIn ? data.closeIn : 3000;
      data.created = new Date();

      this.items.push(data);
      this.index += 1;
      this.count();
    },
    pop(index) {
      this.items.splice(index, 1);
      this.count();
    },
    count() {
      this.items.forEach((item, idx) => {
        if (new Date() - item.created >= item.closeIn) {
          this.pop(idx);
        }
      });
    },
    iconByType(type) {
      if (type == "SUCCESS") {
        return require("@/assets/images/alert/success-icon.svg");
      } else if (type == "ERROR") {
        return require("@/assets/images/alert/error-icon.svg");
      } else {
        return require("@/assets/images/alert/info-icon.svg");
      }
    },
  },
  created() {},
  mounted: function () {
    window.setInterval(() => {
      this.count();
    }, 1000);
  },
};
</script>

<style scoped>
.alert-card {
  z-index: 10000;
  display: block;
  width: 290px;
  position: absolute;
  top: 50px;
  right: 5px;
  background-color: white;
  border-radius: 3px;
  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.6);
  padding: 10px;
}
.alert-success {
  border-left: 3px solid #4caf50;
}
.alert-error {
  border-left: 3px solid #f44336;
}
.alert-info {
  border-left: 3px solid #2196f3;
}
.alert-content {
  /*white-space: nowrap;*/
  display: inline-block;
  width: 100%;
}
.alert-icon {
  max-width: 25px;
  min-width: 25px;
  width: 100%;
  margin-top: 3px;
}

.alert-title {
  display: inline-block;
  margin-left: 5px;
  margin-top: 8px;
  max-width: 200px;
  font-size: 14px;
}

.alert-title-long {
  display: inline-block;
  margin-left: 5px;
  max-width: 200px;
  font-size: 12px;
}
.alert-close {
  margin-top: 5px;
  float: right;
  font-size: 20px;
  cursor: pointer;
}

.slide-leave-active,
.slide-enter-active {
  transition: 0.5s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(100%, 0);
}
</style>
